import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        border: `8px solid ${theme.palette.common.white}`,
        margin: 16,
        padding: "36px 0 0",
        background: `rgba(255,255,255,0.9)`,
        boxShadow: [
            `0px 16px 26px 0px ${theme.palette.primary.main}99`,
            theme.shadows[15]
        ]
    },
    labformContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    pageTitle: {
        padding: "0 8px",
        fontSize: '16px',
        fontWeight: "500",
        color: '#000',
    },
    gridContainer: {
        display: 'flex',
        justifyContent: 'right',
        "@media(max-width:876px)": {
            " & .MuiGrid-item": {
                " & .MuiButtonBase-root": {
                    width: 80,
                }
            }
        }
    },
    prevBtn: {
        background: '#fff',
        color: '#1d1d1d',
        border: '1px solid #1d1d1d',
        marginLeft: 8,
        marginRight: 8,
        width: 110,
        fontSize: 12,
        [theme.breakpoints.down("xs")]: {
            fontSize: 10,
            width: 90
        },
        " &:hover": {
            background: '#fff'
        }
    },
    nextBtn: {
        background: '#1d1d1d',
        color: '#fff',
        width: 110,
        fontSize: 12,
        [theme.breakpoints.down("xs")]: {
            fontSize: 10,
            width: 90
        },
        " &:hover": {
            background: '#1d1d1d',
        }
    },
    consoleButtons: {
        background: '#71757b',
        color: '#fff',
        width: 132,
        fontSize: 12,
        marginLeft: 8,
        marginRight: 8,
        [theme.breakpoints.down("xs")]: {
            fontSize: 10,
            width: 90
        },
        " &:hover": {
            background: '#71757b',
        }
    },
    disableBtn: {
        background: '#e1e2e3',
        color: 'white !important',
        border: '1px solid #e1e2e3',
        width: 110,
        fontSize: 12,
        marginLeft: 8,
        marginRight: 8,
    },
    select: {
        marginTop: '8px !important',
        marginBottom: '8px',
        width: '100%',
    },
    labMaster: {
        padding: '24px 24px 0px 24px',
    },
    mainClass: {
        height: 106,
        width: 106,
        borderRadius: "50%",
        boxShadow: [
            `0px 16px 26px -10px ${theme.palette.primary.main}a5`,
            theme.shadows[5]
        ],
        margin: 8,
        color: theme.palette.primary.light,
        border: `3px solid ${theme.palette.common.white}`,
        filter: "grayscale(1)",
        transition: theme.transitions.create(),
        "&:active": {
            filter: "grayscale(0)",
            border: `3px solid ${theme.palette.primary.main}`
        },
        "&:hover": {
            filter: "grayscale(0)",
            border: `3px solid ${theme.palette.primary.main}`
        }
    },
    mainLblClass: {
        color: theme.palette.grey[700],
        textTransform: "uppercase",
        letterSpacing: 1,
        marginBottom: 16,
        cursor: "pointer"
    },
    checked: {
        filter: "grayscale(0)",
        border: `3px solid ${theme.palette.primary.main}`
    },
    LblChecked: { color: theme.palette.primary.main },
    itemInner: {
        height: 66,
        width: 66,
        borderRadius: "50%",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        boxShadow: theme.shadows[9]
    },
    input: {
        cursor: "pointer",
        height: 106,
        width: 106,
        position: "absolute",
        top: -6,
        left: -6,
        opacity: 0
    },
    gridOutline: {
        marginTop: 6,
        "& .MuiFormLabel-root.Mui-focused": {
            color: '#2a2c2e',
        }
    },
    textField: {
        "& input::placeholder": {
            fontSize: "14px"
        },
        "& .MuiInputBase-root.Mui-disabled": {
            background: '#ccc',
            opacity: .3
        },
        "& .MuiFormLabel-root.Mui-focused": {
            color: '#2a2c2e',
        }
    },
    inputField: {
        fontSize: 14,
        padding: '12px !important',
        margin: 0
    },
    base: {
        '&$focused $notchedOutline': {
            borderColor: '#2a2c2e',
            border: '1px solid #2a2c2e',
        },
    },
    focused: {
    },
    notchedOutline: {
        border: "1px solid #2a2c2e !important",
    },
    margin: {
        marginTop: 16,
    },
    itemList: {
        minHeight: '0px',
        marginTop: '12px',
        " & .MuiSvgIcon-root": {
            width: 20,
            height: 20,
        }
    },
    menuItem: {
        fontSize: 14,
        padding: '6px 12px 6px 12px '
    },
    checkboxItem: {
        padding: 0,
        width: 'max-content',
        " & .MuiTypography-root": {
            fontSize: 14,
        }
    },
    nestedCheckbox: {
        width: 'max-content',
        padding: '0px 0px 0px 18px',
    },
    checkbox: {
        padding: 2,
    },
    itemText: {
        " & .MuiTypography-root": {
            fontSize: 14
        }
    },
    row: { borderBottom: `1px solid ${theme.palette.grey[100]}` },
    icon: {
        fill: theme.palette.grey[700],
        width: 28,
        height: 28
    },
    expandAccordion: {
        width: 24,
        height: 24,
        marginLeft: 4,
        position: 'relative',
        top: 1
    },
    collapseAccordion: {
        width: 24,
        height: 24,
        marginLeft: 4,
        position: 'relative',
        top: 1,
        transform: 'rotate(180deg)'
    },
    subheader: {
        textDecoration: 'underline',
        fontWeight: 500,
        marginTop: 8,
        marginBottom: 8,
        background: "#e1e2e3",
        padding: '4px 6px 4px 6px'
    },

    label: {
        color: '#2a2c2e',
    },

    cancelBtn: {
        background: '#fff',
        color: '#1d1d1d',
        border: '1px solid #1d1d1d',
        width: 110,
        fontSize: 12,
        cursor: 'pointer',
        marginRight: 12,
        marginTop: 6,
        [theme.breakpoints.down("xs")]: {
            fontSize: 10,
            width: 90
        },
        " &:hover": {
            background: '#fff',
        }
    },
    saveBtn: {
        background: '#1d1d1d',
        color: '#fff',
        width: 110,
        fontSize: 12,
        marginTop: 6,
        cursor: 'pointer',
        [theme.breakpoints.down("xs")]: {
            fontSize: 10,
            width: 90
        },
        " &:hover": {
            background: '#1d1d1d',
        }
    },
    selectLabel: {
        fontSize: 14,
        color: '#2a2c2e',
        fontWeight: 500,
        minWidth: 122,
        margin: 'auto 0',
        marginRight: 12,
        whiteSpace: 'inherit',
        textAlign: 'right',

    },
    consoleInputField: {
        padding: '8px !important',
        fontSize: 14
    },
    consoleTextField: {
        marginTop: '8px !important',
        "& input::placeholder": {
            fontSize: "14px"
        },
        "& .MuiInputBase-root.Mui-disabled": {
            background: '#ccc',
            opacity: .3
        },
        "& .MuiFormLabel-root.Mui-focused": {
            color: '#2a2c2e',
        }
    },
    consoleBase: {
        marginBottom: '8px',
        '&$focused $notchedOutline': {
            borderColor: '#2a2c2e',
            border: '1px solid #2a2c2e',
        },
    },
    inputLabel: {
        fontSize: 14,
        color: '#000',
        fontWeight: 500,
        marginRight : '10px'
    },
    textfieldRoot: {
        display: 'flex',
    },
}));